import React from 'react'
import { CheckboxInput } from './CheckboxInput'
import type { InlineInputProps } from '../InlineInput'
import { InlineInput } from '../InlineInput'

export const CheckboxInlineInput = ({
  parentInputComponent,
  name = 'isValid',
  displayContent,
  inputProps,
  ...rest
}: InlineInputProps) => {
  const ParentInput = parentInputComponent || InlineInput
  displayContent = displayContent ?? ((value) => (value ? 'YES' : 'NO'))
  return (
    <ParentInput
      {...{
        ...rest,
        name,
        displayContent,
        editContent: ({ setNewValue, ...props }) => (
          <CheckboxInput {...{ ...props, onChange: (e) => setNewValue(e), ...inputProps }} />
        ),
      }}
    />
  )
}
